export type ThemeMode = "light" | "dark" | "system";

const STORAGE_KEY = "theme";

function resolve(mode: ThemeMode): boolean {
  if (mode === "dark") return true;
  if (mode === "light") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

function apply(mode: ThemeMode): void {
  if (typeof document === "undefined") return;
  const dark = resolve(mode);
  document.documentElement.classList.toggle("dark", dark);
  document.documentElement.style.colorScheme = dark ? "dark" : "light";
}

class Theme {
  mode = $state<ThemeMode>("system");
  private started = false;

  /** Called once from the root layout; the inline script in app.html handles first paint. */
  init(): void {
    if (this.started || typeof window === "undefined") return;
    this.started = true;
    const stored = (localStorage.getItem(STORAGE_KEY) as ThemeMode | null) ?? "system";
    this.mode = stored;
    apply(stored);
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", () => {
        if (this.mode === "system") apply("system");
      });
  }

  set(mode: ThemeMode): void {
    this.mode = mode;
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      /* ignore */
    }
    apply(mode);
  }
}

export const theme = new Theme();
